import { useMutation, useQueryClient } from '@tanstack/react-query'

import {
  CreateSingleReservationBody,
  CreateSingleReservationResponse,
  createSingleReservationResponseSchema,
} from '../../../common/validations/reservationSchema'
import { post } from '../apiClient'
import { throwOnAccessDenied } from '../throwOnAccessDenied'
import { API_ENDPOINTS } from '../../../common/apiEndpoints'

export type CreateSingleReservationRequest = CreateSingleReservationBody

export const useAPIInitSingleReservationPayment = (contractUuid: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (
      request: CreateSingleReservationRequest
    ): Promise<CreateSingleReservationResponse> => {
      const response = await post(
        `/contracts/${contractUuid}/single-reservation`,
        request as unknown as Record<string, unknown>,
        createSingleReservationResponseSchema
      )
      return response
    },
    throwOnError: throwOnAccessDenied,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/reservation-calendars`,
        ],
      })

      queryClient.invalidateQueries({
        predicate: (query) => {
          const key = query.queryKey[0] as string
          return (
            key?.includes(
              `${API_ENDPOINTS.CONTRACTS}/${contractUuid}/reservation-calendars`
            ) && key?.includes('/time-slots')
          )
        },
      })

      queryClient.invalidateQueries({
        queryKey: ['reservations', contractUuid],
      })
    },
  })
}
